import WixSDK from 'shared/utils/wix-sdk';


export default function openPackagePicker() {
  return new Promise(function (resolve) {

    function onMessage({ origin, data }) {
      if (!/wix\.com\/?$/.test(origin)) {
        return;
      }

      try {
        if (JSON.parse(data).purchaseStatus === 'ok') {
          window.removeEventListener('message', onMessage, false);
          resolve();
        }
      } catch (error) {
      }
    }

    window.addEventListener('message', onMessage, false);
    WixSDK.SuperApps.Settings.openBillingPage();
  });
}



// WEBPACK FOOTER //
// ./src/shared/utils/open-package-picker.js